// @ts-nocheck

import { selectGRMiscCurrentNotification, selectGRMiscTmpNotifications } from '../misc';
import { selectGRBetsFromRound } from '../round';

const { createSelector } = require('reselect');

const getGRChipIndexFromProps = (_, { index }) => index ?? null;

const selectGRBet = createSelector(
  [selectGRBetsFromRound, getGRChipIndexFromProps],
  (bets, index) => bets[index] ?? { counted: false },
);

const selectGRBetStatus = createSelector([selectGRBet], (bet) => bet?.status);

const selectGRBetCounted = createSelector([selectGRBet], (bet) => bet?.counted ?? false);

const selectGRBetBetslipReference = createSelector([selectGRBet], (bet) => bet?.betslipReference);

const selectBetStatus = createSelector(
  [selectGRBetStatus, selectGRBetBetslipReference, selectGRMiscTmpNotifications],
  (betStatusFromState, betslipReference, notifications) => {
    if (!notifications.length) {
      return betStatusFromState;
    }

    for (let i = 0; i < notifications.length; i++) {
      const notification = notifications[i];
      const {
        data: {
          betslipReference: notifBetslipReference,
          previousStatus: notifPreviousStatus,
          nextStatus: notifNextStatus,
        },
      } = notification;

      if (i === 0) {
        if (notifBetslipReference === betslipReference && notifNextStatus) {
          return notifNextStatus;
        }
      } else {
        if (notifBetslipReference === betslipReference && notifPreviousStatus) {
          return notifPreviousStatus;
        }
      }
    }

    return betStatusFromState;
  },
);

const selectGRChipShouldAnimate = createSelector(
  [selectGRBetBetslipReference, selectGRMiscCurrentNotification],
  (betslipReference, currentNotif) => betslipReference && betslipReference === currentNotif?.data?.betslipReference,
);

const selectGRChipProps = createSelector(
  [
    getGRChipIndexFromProps,
    selectBetStatus,
    selectGRBetCounted,
    selectGRBetBetslipReference,
    selectGRChipShouldAnimate,
  ],
  (index, status, counted, betslipReference, shouldAnimate) => ({
    index,
    status,
    counted,
    betslipReference,
    shouldAnimate,
  }),
);

export default selectGRChipProps;
